/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */
export function isAbortError(error) {
    return (Boolean(error) &&
        error instanceof DOMException &&
        error.name === 'AbortError');
}
